import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Link } from 'react-router-dom'
import { Avatar, DisplayName, HorizontalStack, IconValueBlock, ShowIf, Status } from '@ztechapps/webui.util'
import { PhoneNumberDisplay } from '@ztechapps/webui.input'
import { getCompanyOrProfileName } from '@ztechapps/common.utils'
import type { RouteDef, UserProfile, UserStatusEnum } from '@ztechapps/common.contract'
import { UserTypeEnum } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'

export type CustomerWidgetProps = {
  profile?: UserProfile
  status?: UserStatusEnum
  company?: any
  phone?: string
  showAvatar?: boolean
  contactId?: string
  companyId?: string
  userType?: UserTypeEnum
}
export const CustomerWidget = ({
  profile,
  status,
  company,
  companyId,
  phone,
  contactId,
  userType = UserTypeEnum.customer,
  showAvatar = true,
}: CustomerWidgetProps) => {
  const picture = profile?.picture ?? ''

  const customerContactRoute = useInject<RouteDef>(WebuiIocKey.routes.customerContactItem)
  const companyContactRoute = useInject<RouteDef>(WebuiIocKey.routes.customerCompanyItem)
  const vendorContactRoute = useInject<RouteDef>(WebuiIocKey.routes.vendorContactItem)
  companyId = companyId || company?._id
  let contactLinkTo = ''
  if (!isEmpty(contactId)) {
    if (userType === UserTypeEnum.vendor) {
      contactLinkTo = vendorContactRoute.altPath({ _id: contactId })
    } else if (userType === UserTypeEnum.customer) {
      contactLinkTo = customerContactRoute.altPath({ _id: contactId })
    }
  }

  let companyLinkTo = ''
  if (!isEmpty(companyId)) {
    companyLinkTo = companyContactRoute.altPath({ _id: companyId })
  }

  const profileName = profile?.name || ''

  return (
    <HorizontalStack gap={2} className="mb-2 align-items-start">
      <ShowIf condition={showAvatar}>
        <div>
          <Avatar name={getCompanyOrProfileName({ company, profile })} src={picture} />
        </div>
      </ShowIf>
      <div>
        <div className="fw-bold">
          {status && <Status value={status} />}
          <DisplayName company={company} profile={profile} linkTo={companyLinkTo} />
        </div>
        <ShowIf condition={!isEmpty(profileName)}>
          <div className="small">
            <IconValueBlock
              icon="address-card"
              value={isEmpty(contactLinkTo) ? profileName : <Link to={contactLinkTo}>{profileName}</Link>}
            />
          </div>
        </ShowIf>
        <ShowIf condition={!!profile?.email}>
          <div className="small">
            <IconValueBlock icon="envelope">
              <a href={`mailto:${profile?.email}`}>{profile?.email}</a>
            </IconValueBlock>
          </div>
        </ShowIf>
        <ShowIf condition={!!phone}>
          <div className="small">
            <IconValueBlock icon="phone">
              <a href={`tel:${phone}`}>
                <PhoneNumberDisplay value={phone} />
              </a>
            </IconValueBlock>
          </div>
        </ShowIf>
      </div>
    </HorizontalStack>
  )
}
